import { render, staticRenderFns } from "./LeadGenerationCards.vue?vue&type=template&id=536265ef&scoped=true"
import script from "./LeadGenerationCards.vue?vue&type=script&lang=js"
export * from "./LeadGenerationCards.vue?vue&type=script&lang=js"
import style0 from "./LeadGenerationCards.vue?vue&type=style&index=0&id=536265ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536265ef",
  null
  
)

export default component.exports